/* eslint-disable indent */
import styled, { css } from 'styled-components';
export const getColors = (props) => {
    const { as, variant = 'default' } = props;
    const stylesList = {
        default: css`
            ${({ pullRight}) => `
                ${pullRight ? `margin-left: auto !important;` : ''}
            `}
            background-color: ${as === 'a'
                ? 'transparent'
                : 'var(--theme-btn-base-bg)'};
            border: ${as === 'a' ? 'none' : `1px solid var(--theme-btn-base-border)`};
            color: var(--theme-btn-base-color);
            &:hover {
                background-color: var(--theme-btn-base-active);
            }
            .inx-fa-icon {
                color: var(--theme-btn-base-svg);
            }
            &.btn--main {
                height: 32px;
                background-color: var(--theme-aside-compose-btn-bg);
                border-color: var(--theme-aside-compose-btn-bg);
                color: var(--theme-aside-compose-btn-text);
                font-weight: bold;
                &:hover {
                    background-color: var(--theme-aside-compose-btn-bg-active);
                }
            }
        `,
        disabled: css`
            background-color: var(--color-gray-100);
            border: ${as === 'a' ? 'none' : `1px solid var(--color-gray-300)`};
            color: var(--color-gray-500);
            pointer-events: none;
            user-select: none;
            .inx-fa-icon {
                color: var(--color-gray-500);
            }
        `,
        primary: css`
            background-color: ${as
                ? 'transparent'
                : 'var(--color-fire)'};
            border: ${as ? 'none' : `1px solid transparent`};
            color: var(--color-white);
            &:hover {
                color: var(--color-white);
                background-color: var(--warning-bg-active);
            }
            .inx-fa-icon {
                color: var(--color-white);
            }
        `,
        secondary: css`
            background-color: ${as
                ? 'transparent'
                : 'var(--color-gray-100)'};
            border: ${as ? 'none' : `1px solid var(--color-gray-400)`};
            color: var(--color-gray-800);
            &:hover {
                color: var(--color-gray-800);
                background-color: var(--color-gray-100);
            }
            .inx-fa-icon {
                color: var(--color-gray-600);
            }
        `,
        link: css`
            background-color: transparent;
            border: 0;
            color: var(--color-gray-800);
            &:hover {
                color: var(--color-gray-800);
                .inx-fa-icon {
                    color: var(--color-gray-800);
                }
            }
        `
    };
    return stylesList[variant];
};

export const baseStyles = css`
    height: 36px;
    align-items: center;
    border-radius: 2px;
    border: 0;
    cursor: pointer;
    display: inline-flex;
    margin: 0;
    padding: .45em .5em;
    transition: background-color .2s linear;
    white-space: nowrap;
`;

export const Button = styled.button.attrs((props) => ({
    disabled: props.variant === 'disabled' || false,
    type: props.as ? null : props.type || 'button'
}))`
    ${baseStyles}
    &:nth-child(even) {
        margin: 0 .25em;
    }
    &:last-child {
        margin-right: 0;
    }
    &:focus {
        outline: none;
    }
    .inner-text {
        margin-left: .4em;
    }
    .inx-fa-icon {
        color: var(--color-gray-600);
    }
    &.button--navigate {
        svg path {
            fill: var(--theme-ml-toolbar-button-navigate-icon);
        }
        &:hover {
            background-color: var(--theme-ml-toolbar-button-navigate-active);
            svg path {
                fill: var(--theme-ml-toolbar-button-navigate-icon-active);
            }
        }
    }
    &.button--compose {
        padding: 0 .5em;
    }
    &.button--as-link {
        padding : 0;
        background: transparent;
        border: none;
        color: var(--color-water);
        
        &:hover {
            background-color: transparent;
            color: var(--color-ocean);
        }
    }
    ${({ theme }) => theme.breakpoint.name == 'xs' && `
        width: 36px;
        &:nth-child(even) {
            margin: 0 .3em;
        }
        &:last-child {
            margin-right: 0;
        }
        &.button--compose {
            padding: .45em .5em;
        }
        &[class*="btn-send"],
        &[class*="dropdown-toggle"],
        &[data-action="reply"],
        &[data-action="reply-to-all"]{
            width: auto;
        }
        
    `}
    ${(props) => getColors(props)}
    
    &.button--mark-as {
        margin-left: 1.5em;
    }
    
    &:focus-visible {
        outline: 1px solid var(--brand-primary);
    }
`;
